import { Center, Box, Divider, HStack, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

import Logo from 'components/Logo';
import Text from 'components/Text';

import { useMediaQueries } from './MediaQueriesProvider';

interface OnboardingLayoutProps {
  children: ReactNode;
  isOnboarding?: boolean;
  step?: 1 | 2 | 3;
  totalSteps?: number;
}

export const OnboardingLayout = ({
  children,
  isOnboarding,
  step,
  totalSteps = 2,
}: OnboardingLayoutProps) => {
  const { isOnboardingHorizontal, isDesktopProjects } = useMediaQueries();

  return (
    <Box height="100vh" mx={isDesktopProjects ? 2 : 0} display="flex" flexDirection="column">
      <Center pt={!isOnboardingHorizontal && isOnboarding ? 3 : 6}>
        <Logo />
      </Center>

      {step && (
        <VStack spacing={0} mt={4}>
          <HStack spacing={3} mb={3}>
            <Text fontSize="small" opacity="secondary" fontWeight="semibold">
              Step {step} of {totalSteps}
            </Text>
            <HStack spacing={1.5}>
              {Array.from({ length: totalSteps }, (_, i) => (
                <Box
                  key={i}
                  w="40px"
                  h="4px"
                  borderRadius="full"
                  bg={i < step ? 'purple.400' : 'whiteAlpha.200'}
                  transition="background 0.3s ease"
                />
              ))}
            </HStack>
          </HStack>
          <Divider borderColor="whiteAlpha.100" />
        </VStack>
      )}

      <Center flex="1" w="100%">
        <VStack w="100%">{children}</VStack>
      </Center>
    </Box>
  );
};
